export const THE_ESTATE_OF = "The Estate of"
